<h2 mat-dialog-title>
	<mat-icon style="margin-right: 8px">person_add</mat-icon>{{ 'client.create.title' | transloco }}
</h2>
<mat-dialog-content>
	<form class="dialog-window" [formGroup]="form">
		<div>
			<p lvrPadding [padVertical]="8">{{ 'client.create.hint1' | transloco }}</p>
			<mat-form-field lvrInput [class]="showWarning() ? 'lvr-warning' : ''">
				<input
					matInput
					formControlName="clientName"
					[placeholder]="'client.create.placeholder' | transloco"
					[matAutocomplete]="auto"
				/>
				<mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayName">
					@if (form.get('clientName')?.value && suggestions().length <= 0) {
						<mat-option disabled>
							{{ 'client.create.no_suggestion' | transloco }}
						</mat-option>
					} @else {
						@for (client of suggestions(); track client.id) {
							<mat-option [value]="client">
								<div class="option-row">
									<div>
										<span> {{ client.firstName }} {{ client.lastName }} </span>
										<br />
										<span class="text-sm">
											{{ client.dateOfBirth | date: 'dd.MM.yyyy' }}
										</span>
									</div>

									@if (client.archiveId) {
										<div class="chips">
											<lvr-chip [icon]="'assignment'" [name]="'global_search.completed' | transloco"></lvr-chip>
											<lvr-chip [icon]="'inventory_2'" [name]="'global_search.archive' | transloco"></lvr-chip>
										</div>
									}
								</div>
							</mat-option>
						}
					}
				</mat-autocomplete>
				@if (showWarning()) {
					<mat-hint class="lvr-warning">{{ 'client.create.suggestion_found' | transloco }}</mat-hint>
				}
			</mat-form-field>
		</div>
		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'base.button.cancel' | transloco"
				[type]="'button'"
				(clicked)="selfRef.close()"
				icon="disabled_by_default"
			></lvr-button>
			<lvr-button
				variant="primary"
				[label]="btnText() | transloco"
				[type]="'button'"
				[disabled]="form.invalid"
				(clicked)="done()"
				icon="add"
			></lvr-button>
		</mat-dialog-actions>
	</form>
</mat-dialog-content>
